import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

// eslint-disable-next-line import/prefer-default-export
export const StyledToolTip = styled.span<{ width?: number }>`
  width: ${({ width = 100 }) => `${width}px`};

  position: absolute;

  margin-top: 10px;
  margin-left: ${({ width = 100 }) => `-${width / 2}px`};
  padding: 5px 0;
  top: 100%;
  left: 50%;

  background-color: ${DIGIPOSTHEME.colors.primaryAkbankWhite};

  visibility: hidden;

  color: ${DIGIPOSTHEME.colors.secondaryGrayPrimary};
  font-family: "Campton";
  font-size: 12px;
  font-weight: 500;
  text-align: center;

  border-radius: 6px;

  box-shadow: rgb(0 0 0 / 20%) 0px 2px 5px 2px;

  z-index: 200;
  opacity: 0;

  transition: opacity 0.3s;

  @media ${MEDIA_QUERIES.MOBILE} {
    left: ${({ width = 100 }) => `-${width / 4}px`};
  }

  ::after {
    content: "";
    position: absolute;

    margin-left: -10px;
    bottom: 100%;
    left: 50%;

    border-width: 5px;
    border-style: solid;
    border-color: ${DIGIPOSTHEME.colors.primaryAkbankWhite} transparent
      transparent transparent;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;

    z-index: 1001;

    transform: rotate(180deg);

    filter: drop-shadow(rgba(0, 0, 0, 0.19) 0px 1px 1px);

    @media ${MEDIA_QUERIES.MOBILE} {
      margin-left: -5px;
      left: 80%;
    }
  }
`;
